import { createFileRoute, useNavigate } from '@tanstack/react-router';
// Route options read the light search module; the page is code-split with the component.
import { ProjectsPage } from '@/features/projects/pages/projects-page';
import { ProjectsSearchSchema } from '@/features/projects/search';

/** Projects of the organisation: grid or list with filters kept in the address. */
export const Route = createFileRoute('/_auth/o/$orgId/projects/')({
  validateSearch: (search) => ProjectsSearchSchema.parse(search),
  component: ProjectsRoute,
});

function ProjectsRoute() {
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ProjectsPage
      orgId={orgId}
      search={search}
      onSearchChange={(patch) => {
        void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true });
      }}
    />
  );
}
